export default {
  'messages.listEmptyText': 'There are no records to display',
  'messages.noOption': 'No options',
};
